import { Box, Typography, Grid, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom"; // Import from React Router
import Samriddhi from "../components/SamriddhiIcon.jpg";

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#fff",
                padding: "40px 24px",
                borderTop: "1px solid #ddd",
                color: "black"
            }}
        >
            <Grid
                container
                spacing={4}
                justifyContent="center"
                alignItems="flex-start"
                textAlign={{ xs: "center", sm: "left" }}
            >
                <Grid item xs={12} sm={6} md={3}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "center", sm: "flex-start" },
                            mb: 2
                        }}
                    >
                        <img
                            src={Samriddhi}
                            alt="Samriddhi Trust Icon"
                            style={{
                                width: 100,
                                height: 100,
                                borderRadius: "20%",
                                boxShadow: "0 4px 24px rgba(93,156,164,0.18)",
                                border: "4px solid #5d9ca4",
                                background: "#fff"
                            }}
                        />
                    </Box>
                    <Typography variant="h6">Samriddhi Trust</Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom>
                        Discover who we are
                    </Typography>
                    <Typography variant="body2">
                        Learn more about us
                        <br />
                        <Link to="/about" style={{ textDecoration: "underline", color: "inherit" }}>
                            Know more.
                        </Link>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom>
                        View Our Work
                    </Typography>
                    <Link to="/programs" style={{ textDecoration: "underline", color: "inherit" }}>
                        Programs
                    </Link>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom>
                        We're here to help
                    </Typography>
                    <Typography variant="body2">
                        Join Our Community
                        <br />
                        <Link to="/contact" style={{ textDecoration: "underline", color: "inherit" }}>
                            Contact us.
                        </Link>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6" gutterBottom>
                        Designed and Developed by
                    </Typography>
                    <Typography variant="body2">
                        Harshit Chaturvedi
                        <br />
                        <MuiLink
                            href="https://harshitchaturvedi.netlify.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            color="inherit"
                        >
                            View Profile
                        </MuiLink>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
